```jsx
import { List } from '@shieldpay/bumblebee/list';
import { Text } from '@shieldpay/bumblebee/text';


<Heading>Unordered Default List</Heading>

<List size="small">
  <List.Item
    label="First"
    LeftIcon={<EmptyCheckIcon />}
  >
    Unordered List item
  </List.Item>
  <List.Item
    label="Second"
    RightIcon={<ChevronRightIcon />}
  >
    Unordered List item
  </List.Item>
</List>


<Heading>Ordered Timeline List</Heading>

<List ordered>
  <List.Item
    variant="timeline"
    LeftIcon={<EmptyCheckIcon />}
  >
    <Text>First</Text>
    <Text>Ordered List item</Text>
  </List.Item>
  <List.Item variant="timeline">
    <Text>Ordered List item<Text>
  </List.Item>
</List>
```

/
